<template>
  <div class="notice-block">
    <h5 v-if="!hideTitle" class="mb-50">{{ item.notice.title }}</h5>
    <div class="notice-text">{{ item.notice.body }}</div>

    <!-- tick acknowledgement -->
    <template v-if="!isSignature">
      <b-form-checkbox v-model="value.acknowledged" :disabled="disabled" class="ack-check mt-1">
        {{ item.notice.ackLabel || "I have read and understood the above" }} *
      </b-form-checkbox>
      <small v-if="showHint && !value.acknowledged && !disabled" class="text-danger d-block">
        Please confirm that you have read and understood this notice before signing.
      </small>
    </template>

    <!-- name + drawn signature -->
    <template v-else>
      <div v-if="disabled" class="signed-box mt-1">
        <feather-icon :icon="existing ? 'CheckCircleIcon' : 'ClockIcon'" size="18" :class="existing ? 'text-success mr-50' : 'text-muted mr-50'" />
        <span v-if="existing">
          Signed by <strong>{{ existing.name || value.name || "—" }}</strong>
          <template v-if="existing.signedAt">on <strong>{{ formatDate(existing.signedAt) }}</strong></template>
        </span>
        <span v-else class="text-muted">Not signed yet.</span>
      </div>

      <template v-else>
        <b-alert v-if="existing" show variant="success" class="p-75 mt-1">
          <small>
            Already signed by <strong>{{ existing.name || "—" }}</strong>
            <template v-if="existing.signedAt">on {{ formatDate(existing.signedAt) }}</template>.
            Sign again below only if you wish to replace that signature.
          </small>
        </b-alert>
        <b-row class="mt-1">
          <b-col cols="12" md="6">
            <b-form-group :label="(item.notice.ackLabel || 'Name (only by an authorised signatory)') + (existing ? '' : ' *')">
              <validation-provider #default="{ errors }" :rules="existing ? '' : 'required'" :name="item.notice.title + ' signatory'">
                <b-form-input v-model="value.name" :state="errors.length ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group :label="'Signature' + (existing ? '' : ' *')">
          <signature-pad ref="pad" :active="active" height="160px" />
        </b-form-group>
        <small v-if="showHint && !hasSignature && !existing" class="text-danger d-block">Please sign this notice before submitting.</small>
      </template>
    </template>
  </div>
</template>

<script>
// A "read and sign" notice of the form schema. `value` is the stored {acknowledged, name}
// object (edited in place). `existing` is the signature already on file, if any.
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import SignaturePad from "./SignaturePad.vue";
import { formatDate } from "./publicApi";

export default {
  name: "NoticeBlock",

  components: { ValidationProvider, SignaturePad },

  props: {
    item: { type: Object, required: true },
    value: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    showHint: { type: Boolean, default: false },
    active: { type: Boolean, default: true },
    hideTitle: { type: Boolean, default: false },
    existing: { type: Object, default: null },
  },

  data() {
    return { required, hasSignature: false };
  },

  computed: {
    isSignature() {
      return this.item.notice && this.item.notice.ackMode === "Signature";
    },
  },

  methods: {
    formatDate,

    // PNG data URL of the drawn signature, or null
    signature() {
      const pad = this.$refs.pad;
      const image = pad ? pad.save() : null;
      this.hasSignature = !!image;
      return image;
    },
  },
};
</script>
